import { StyledContent, StyledGallery } from '@/components/styles';
import { Picture, Directions, Modal, Gallery } from '@/components';
import { useMemo, useState } from 'react';

export default function Portfolio({ data }) {
  const [activeThumb, setActiveThumb] = useState(0);
  const dataDirections = Array.from(
    new Set([...data].filter((item) => item.direction).map((item) => item.direction.slug))
  );

  const defaultDirection = {
    id: 'all',
    title: 'All directions',
    service_count: 1,
    slug: 'all',
    subdirections: [],
  };

  const directions = [
    defaultDirection,
    ...[...dataDirections].map(
      (item) =>
        [...data]
          .filter((i) => i.direction)
          .map((i) => i.direction)
          .filter((i) => i.slug == item)[0]
    ),
  ];

  const [currentDirection, setCurrentDirection] = useState(defaultDirection);

  const handleClick = (slug) => {
    if (slug == 'all') {
      setCurrentDirection(defaultDirection);
    } else {
      const cur = [...directions].filter((item) => item.slug == slug);
      setCurrentDirection(cur[0]);
    }
  };

  const items = useMemo(
    () =>
      currentDirection.slug == 'all'
        ? [...data]
        : [...data].filter((item) => item.direction?.slug == currentDirection.slug),
    [data, currentDirection]
  );

  const imgs = [];
  items.forEach((item) => {
    imgs.push(item.imageBefore);
    imgs.push(item.imageAfter);
  });

  return (
    <>
      <div style={{ overflow: 'hidden' }}>
        {!!directions?.length && (
          <Directions directions={directions} active={currentDirection} onClick={handleClick} size="mid" />
        )}
      </div>
      <StyledContent.BeforeAfterItems>
        {items &&
          items.length > 0 &&
          items.map((item, ind) => {
            const { id, imageBefore, imageAfter, before_alt, after_alt } = item;
            return (
              <StyledContent.BeforeAfterItem key={id}>
                <StyledContent.BeforeAfterPart>
                  <div
                    style={{ position: 'relative' }}
                    onClick={() => {
                      setActiveThumb(ind * 2);
                    }}
                  >
                    <Picture {...imageBefore} alt={before_alt || 'before'} isLazy={true}/>
                    <Modal render={StyledGallery.ModalTrigger} view="gallery">
                      <Gallery inModal images={{ main: imgs, modal_thumb: imgs }} initialInd={activeThumb} />
                    </Modal>
                  </div>
                  <StyledContent.Html
                    size="small"
                    dangerouslySetInnerHTML={{ __html: '<p style="color:#b69b64" >BEFORE</p>' }}
                  />
                </StyledContent.BeforeAfterPart>
                <StyledContent.BeforeAfterPart>
                  <div
                    style={{ position: 'relative' }}
                    onClick={() => {
                      setActiveThumb(ind * 2 + 1);
                    }}
                  >
                    <Picture {...imageAfter} alt={after_alt || 'after'} isLazy={true}/>
                    <Modal render={StyledGallery.ModalTrigger} view="gallery">
                      <Gallery inModal images={{ main: imgs, modal_thumb: imgs }} initialInd={activeThumb} />
                    </Modal>
                  </div>
                  <StyledContent.Html
                    size="small"
                    dangerouslySetInnerHTML={{ __html: '<p style="color:#b69b64">AFTER</p>' }}
                  />
                </StyledContent.BeforeAfterPart>
              </StyledContent.BeforeAfterItem>
            );
          })}
      </StyledContent.BeforeAfterItems>
    </>
  );
}
